import { useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO = "/checkin-tarife-logo.png";

export default function LegalShell({ title, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} – Check'in Tarife`;
  }, [title]);

  return (
    <div className="legal-page">
      <header className="site-header">
        <div className="shell nav-shell legal-nav">
          <Link className="brand" to="/" aria-label="Check'in Tarife Startseite">
            <img src={LOGO} alt="Check'in Tarife" />
          </Link>
          <Link className="button button-ghost button-small" to="/" data-testid="legal-back-home">← Zur Startseite</Link>
        </div>
      </header>

      <main className="legal-main" id="main">
        <div className="shell legal-wrap">
          <span className="kicker">Rechtliches</span>
          <h1 className="legal-title">{title}</h1>
          <div className="legal-content">{children}</div>
          <div className="legal-foot-nav">
            <Link className="button button-navy button-small" to="/" data-testid="legal-home-bottom">Zur Startseite</Link>
            <Link className="footer-link legal-cross" to="/impressum">Impressum</Link>
            <Link className="footer-link legal-cross" to="/datenschutz">Datenschutz</Link>
          </div>
        </div>
      </main>

      <footer className="site-footer legal-footer">
        <div className="shell footer-bottom">
          <span>© {new Date().getFullYear()} Check'in Tarife GbR</span>
          <span style={{ display: "flex", gap: 18 }}>
            <Link className="footer-link" to="/impressum">Impressum</Link>
            <Link className="footer-link" to="/datenschutz">Datenschutz</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}
